module.exports = __webpack_public_path__ + "img/default_img.e052ccc2.png";